export default __webpack_public_path__ + "static/media/scissors-01.33bdbd72.png";